import { seoMeta } from "@/lib/ui/seo";
import { FIND_HERO_POSTER_SRC } from "./find-hero-background";

export function findPageHead(url: "/" | "/find") {
    const head = seoMeta({
        title: "Find a dog that fits your life — Wags",
        description:
            "Browse dogs from breeders, shelters, and rescues near you. Filter by breed, age, and distance to find your perfect match.",
        url,
    });
    return {
        ...head,
        links: [
            ...head.links,
            {
                rel: "preload",
                href: FIND_HERO_POSTER_SRC,
                as: "image",
                type: "image/jpeg",
                fetchPriority: "high" as const,
            },
        ],
    };
}
